/* 
https://dev.azure.com/shieldox/X2O/_workitems/edit/11163
ar01 - restrict access to Add Admin API
ar02 - restrict access to Change Restrictions API
*/

import { POPULATION_TYPE } from "./population.enum";

export type BaseRestrictions = "ar01" | "ar02";

export type AppsRestrictions =
  // Labels Customization
  | "ar03"
  //  Risks Customization
  | "ar04"
  // Trust Management
  | "ar05"
  //  Request Justification
  | "ar06"
  // Investigation
  | "ar07"
  // Policies
  | "ar08"
  // Playbooks
  | "ar09"
  // Reports
  | "ar10"
  // MS labeling
  | "ar11"
  // Data Sources
  | "ar12";

export type InfoTypeRestriction =
  | "it01"
  | "it02"
  | "it03"
  | "it04"
  | "it05"
  | "it06"
  | "it07";

export type EntityRestriction = "et01" | "et02" | "et03" | "et04" | "et05";

export type Restriction =
  | InfoTypeRestriction
  | EntityRestriction
  | AppsRestrictions
  | BaseRestrictions;

export type RestrictedAppName =
  | "info_type_customization"
  | "risk_type_customization"
  | "trust_management"
  | "event_justification"
  | "entity_investigation"
  | "security_policies"
  | "playbooks"
  | "reports"
  | "microsoft_labeling"
  | "data_sources";

const restriction_app: [Restriction, RestrictedAppName][] = [
  ["ar03", "info_type_customization"],
  ["ar04", "risk_type_customization"],
  ["ar05", "trust_management"],
  /* TO ADD */
  ["ar06", "event_justification"],
  ["ar07", "entity_investigation"],
  ["ar08", "security_policies"],
  ["ar09", "playbooks"],
  ["ar10", "reports"],
  ["ar11", "microsoft_labeling"],
  ["ar12", "data_sources"],
];

export const apps_as_list = () => [
  {
    id: "ar03",
    name: "Information Sensitivity",
    desc:
      "Customize the sensitivity assigned to information categories (ex. Accounting)",
    icon: "Label",
  },
  {
    id: "ar04",
    name: "Risk Severity",
    desc:
      "Customize the severity assigned to risk profiles (ex. Shares to Untrusted Organization)",
    icon: "Risk",
  },
  {
    id: "ar05",
    name: "Trust Management",
    desc: "View and manage how entities are trusted with information",
    icon: "User",
  },
  {
    id: "ar06",
    name: "Event Justification",
    desc: "Request and view employees justifications for suspected events",
    icon: "Email",
  },
  {
    id: "ar07",
    name: "Entity Investigation",
    desc: "Investigate entities in your organization and their activities",
    icon: "Investigation",
  },
  /*  {
    id: "ar08",
    name: "Security Policies",
    desc: "lorem ipsum dolor.",
    icon: "File",
  }, */
  /*  {
    id: "ar09",
    name: "Playbooks",
    desc: "lorem ipsum dolor.",
    icon: "Playbook",
  }, */
  {
    id: "ar10",
    name: "Reports",
    desc: "creating downloading & scheduling reports",
    icon: "Report",
  },
  {
    id: "ar11",
    name: "Microsoft Labeling",
    desc:
      "Mapping Microsoft labels to Cognni labels for a better file labeling automation",
    icon: "Ms",
  },
  /*  {
    id: "ar12",
    name: "Data Sources",
    desc: "lorem ipsum dolor.",
    icon: "DataSource",
  }, */
];

export const get_allowed_apps_from_restrictions = (
  restrictions: Restriction[] = []
) => {
  return restriction_app
    .filter(([code, app]) => !restrictions.includes(code))
    .map(([code, app]) => app);
};

export const can_user_use_app = (
  restrictions: Restriction[],
  app_name: RestrictedAppName
) => {
  const [code] = restriction_app.find((d) => d[1] === app_name) as [
    Restriction,
    RestrictedAppName
  ];
  return !restrictions.includes(code);
};

const restriction_info_type = [
  ["it01", 1], // other
  ["it02", 2], // governance
  ["it03", 3], // business
  ["it04", 4], // finance
  ["it05", 5], // hr
  ["it06", 6], // legal
  ["it07", 7], // personal
];

const restriction_entity = [
  ["et01", "EMPLOYEE"],
  ["et02", "FOLDER"],
  ["et03", "EVENT"],
  ["et04", "CONTACT"],
  ["et05", "ORGANIZATION"],
];

export const all_restrictions = [
  // ...restriction_entity,
  ...restriction_info_type,
  ...restriction_app,
].map((l) => l[0] as string);

export const restriction_to_info_type_code = Object.fromEntries(
  restriction_info_type
);
// @ts-ignore
window.restriction_to_info_type_code = restriction_to_info_type_code;
export const info_type_code_to_restriction = Object.fromEntries(
  restriction_info_type.map((l) => l.reverse())
);

export const restriction_to_entity = Object.fromEntries(restriction_entity);
export const entity_to_restriction = Object.fromEntries(
  restriction_entity.map((l) => l.reverse())
);

export const restriction_to_app = Object.fromEntries(restriction_app);

type RestrictionObject = {
  info: number[];
  entities: POPULATION_TYPE[];
  apps: string[];
};

export const to_restriction_object = (
  restrictions: string[]
): RestrictionObject => {
  return {
    info: restrictions
      .filter((r) => r.startsWith("it"))
      .map((r) => restriction_to_info_type_code[r]),
    entities: restrictions
      .filter((r) => r.startsWith("et"))
      .map((r) => restriction_to_entity[r]),
    apps: restrictions
      .filter((r) => r.startsWith("ar"))
      .map((r) => restriction_to_app[r]),
  };
};
